import type { SVGProps } from "react";
export interface MoneyBillWavyIconProps
  extends Omit<SVGProps<SVGSVGElement>, "width" | "height"> {
  className?: string;
  size?: number;
  color?: string;
}
export function MoneyBillWavyIcon({
  className = "",
  size = 24,
  color = "currentColor",
  ...props
}: MoneyBillWavyIconProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width={size}
      height={size}
      fill="none"
      viewBox="0 0 24 24"
      className={className}
      {...props}
    >
      <path
        fill={color}
        d="M20.875 16.732V5.78l-.002-.022-.146-.05A12 12 0 0 0 17 5.125c-1.816 0-3.425.453-5.043.95-1.561.48-3.25 1.05-4.957 1.05-.811 0-1.587-.08-2.341-.219l-.747-.156c-.363-.086-.6-.141-.777-.173-.007.155-.01.367-.01.69V18.01l.001.208v.022l.147.052.318.098c.796.235 1.977.484 3.409.485 1.816 0 3.426-.453 5.044-.951 1.561-.48 3.248-1.05 4.956-1.05 1.081 0 2.1.143 3.088.376.361.085.6.138.776.17.007-.156.01-.368.01-.689Zm2.25 0c0 .36.001.699-.021.974-.02.24-.063.548-.21.852l-.073.13a2.06 2.06 0 0 1-.99.863l-.184.067c-.393.126-.779.085-1.05.043-.287-.045-.64-.13-1.025-.22A11 11 0 0 0 17 19.125c-1.292 0-2.604.43-4.293.95-1.632.502-3.524 1.05-5.707 1.05-1.689 0-3.087-.293-4.048-.577l-.385-.12c-.206-.068-.502-.155-.8-.364l-.127-.099a2.25 2.25 0 0 1-.617-.852 2.4 2.4 0 0 1-.148-.873V7.267c0-.36 0-.699.022-.975.022-.273.075-.636.281-.98l.109-.164a2.06 2.06 0 0 1 1.066-.766l.147-.04c.34-.075.665-.04.903-.002.287.045.639.129 1.024.22l.637.133A10.7 10.7 0 0 0 7 4.875c1.291 0 2.605-.43 4.294-.95 1.632-.502 3.523-1.05 5.706-1.05 1.93 0 3.48.382 4.433.697l.197.065c.18.062.391.15.604.3l.126.098.189.18c.12.131.23.281.316.437l.112.236.054.155c.076.258.09.508.094.716z"
      />
      <path
        fill={color}
        d="M13.874 12a1.875 1.875 0 1 0-3.75 0 1.875 1.875 0 0 0 3.75 0m-9.499 1.5v-1a1.125 1.125 0 0 1 2.25 0v1a1.125 1.125 0 0 1-2.25 0m13-2v-1a1.125 1.125 0 0 1 2.25 0v1a1.126 1.126 0 0 1-2.25 0m-1.25.5a4.125 4.125 0 1 1-8.25 0 4.125 4.125 0 0 1 8.25 0"
      />
    </svg>
  );
}
